import Vue       from "vue";
import App       from "./App";
import router    from "./router";
import store     from "./store";
import vuescroll from "vue-scroll";
import vueScroll from 'vuescroll';
import 'vuescroll/dist/vuescroll.css';

Vue.use(vueScroll);
Vue.use(vuescroll);
Vue.config.productionTip = false;

export const eventEmmiter = new Vue();

new Vue({
	el:         "#app",
	router,
	store,
	components: { App },
	template:   "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js